import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appQueriesStore } from "@/app/api";
import { submitIntake } from "@/features/forms/api";
import { errorToast } from "@/shared/ui";

export const useSubmitIntake = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: submitIntake,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: appQueriesStore.user.queryKey,
      });
    },
    onError: errorToast,
  });
};
